//import store from './../../store/store'
//import { getGoogleSheets } from './../../common/gsxrest'

const getTodosProdutos = () => {
    return new Array(
        {
            id: 0,
            titulo: 'Plano de Saúde',
            icon: 'fas fa-heartbeat',
            imgname: 'saude.jpg'
        }
    )
}

export {
  getTodosProdutos
}
